import React, { Fragment, useEffect } from 'react';

import FeatureFlag from '@src/components/FeatureFlag';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { buyerSelector } from '@src/features/customers';
import {
  CashbackGrowthOrchestrator,
  CASHBACK_GROWTH_FEATURE_FLAG,
  ConfirmedOrderCard,
  currentOrderSelector,
  getOrderPaymentSummary,
  OrderDetailsCard,
  toOrderPaymentDetails,
} from '@src/features/orders';
import { track } from '@src/services/analytics';

import { useSaleChangeCheckout } from './hooks/useSaleChangeCheckout';

import {
  CashbackGrowthSuccessBannerWrap,
  ConfirmedStepAside,
  ConfirmedStepColumns,
  ConfirmedStepGreeting,
  ConfirmedStepMain,
  ConfirmedStepRoot,
} from './styles';

export const CheckoutSuccessStep = () => {
  const { i18n } = useTranslate();
  const [buyer] = useAppSelector(buyerSelector);
  const order = useAppSelector(currentOrderSelector);
  const onSaleChangeCheckout = useSaleChangeCheckout();

  useEffect(() => {
    track('checkoutSuccessStepAccess');
  }, []);

  if (!order || !buyer) {
    return null;
  }

  return (
    <Fragment>
      <FeatureFlag
        feature={CASHBACK_GROWTH_FEATURE_FLAG}
        active={() => (
          <CashbackGrowthOrchestrator
            order={order}
            renderBanner={(banner) => <CashbackGrowthSuccessBannerWrap>{banner}</CashbackGrowthSuccessBannerWrap>}
          />
        )}
      />

      <ConfirmedStepRoot data-testid='checkout-successful-payment-step'>
        <ConfirmedStepGreeting>{i18n('checkout_confirmed_greeting', { name: buyer.firstName })}</ConfirmedStepGreeting>

        <ConfirmedStepColumns>
          <ConfirmedStepMain>
            <ConfirmedOrderCard order={order} onSaleChangeCheckout={onSaleChangeCheckout} />
          </ConfirmedStepMain>

          <ConfirmedStepAside>
            <OrderDetailsCard
              orderCode={order.code}
              buyer={buyer}
              payment={toOrderPaymentDetails(getOrderPaymentSummary(order), i18n)}
            />
          </ConfirmedStepAside>
        </ConfirmedStepColumns>
      </ConfirmedStepRoot>
    </Fragment>
  );
};

export default CheckoutSuccessStep;
